const initialState = [];
const aiPhotoboothReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case 'FETCH_AI_PHOTOBOOTHS':
			return [...payload];
		case 'ADD_AI_PHOTOBOOTH':
			return [...state, payload.photobooth];
		case 'DELETE_AI_PHOTOBOOTH':
			return state.filter(pb => pb.id !== Number(payload.pbID));
		default:
			return state;
	}
};

export default aiPhotoboothReducer;
